// Plugin to export global app state

let _app = null


export default {
  install(app) {
    _app = app
  }
}